import Image01 from "../img/delat'.jpg";
import Image02 from '../img/eggman.jpg';
import Image03 from '../img/elon.jpg';
import Image04 from '../img/horosh.jpg';
import Image05 from '../img/john.jpg';
import Image06 from '../img/liver.jpg';
import Image07 from '../img/luck.jpg';
import Image08 from '../img/misha.jpg';
import Image09 from '../img/papanya.jpg';
import Image10 from '../img/rock.jpg';
import Image11 from '../img/sniff.jpg';
import Image12 from '../img/sunboy.jpg';
import Image13 from '../img/super.jpg';
import Image14 from '../img/tate.jpg';
import Image15 from '../img/trump.jpg';
import Image16 from '../img/walter.jpg';
import Image17 from '../img/willem.jpg';
import Image18 from '../img/hank.jpg';

const Images = [Image01, Image02, Image03, Image04, Image05, Image06, Image07, Image08, Image09, Image10, Image11, Image12, Image13, Image14, Image15, Image16, Image17, Image18];

export default Images